import { render } from "./NUIColorDot.vue?vue&type=template&id=0bdd952f&scoped=true"
import script from "./NUIColorDot.vue?vue&type=script&lang=js"
export * from "./NUIColorDot.vue?vue&type=script&lang=js"

import "./NUIColorDot.vue?vue&type=style&index=0&id=0bdd952f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdd952f"]])

export default __exports__